import styles from "./styles/duets-voice-card.module.scss";
import Image from "next/image";
import React from "react";
import { useMobile } from "@/hooks/use-responsive";
import { VoiceModel } from "@/actions/db/get-models";
import { useImageErrorHandler } from "@/hooks/use-image-error-handler";
import defaultIcon from "@/assets/models/default.webp";

interface DuetsVoiceCardProps {
  voice: VoiceModel;
  voiceIndex: number;
  children?: React.ReactNode;
}
const DuetsVoiceCard = ({
  children,
  voice,
  voiceIndex,
}: DuetsVoiceCardProps) => {
  const { currentIcon, handleImageError } = useImageErrorHandler(
    voice?.thumbnail || defaultIcon,
    defaultIcon,
  );

  const { isMobile } = useMobile();
  return (
    <div className={styles.voice_info}>
      <div className={styles.icon_voice_info}>
        <div className={styles.image_wrapper}>
          <Image
            src={currentIcon}
            alt={voice.name}
            onError={handleImageError}
            height={isMobile ? 49 : 75}
            width={isMobile ? 49 : 75}
          />
        </div>
        <div className={styles.voice_text_wrapper}>
          <div className={styles.voice_name}>{voice.name}</div>
          <div className={styles.voice_index}>Voice #{++voiceIndex}</div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default DuetsVoiceCard;
